import history from './history'
export default history


// WEBPACK FOOTER //
// ./src/history/index.js